const commentsData = [
  {
    name: '追剧小王',
    time: '2天前',
    content: '用了大半年91免费看片的app了，资源更新速度真的快，热门剧刚播完就能看。播放流畅不卡，画质也清晰，最关键是全部免费！已经推荐给身边所有朋友了。',
    likes: 128,
    avatar: 'W',
    avatarBg: 'bg-primary-500',
  },
  {
    name: '电影爱好者阿杰',
    time: '5天前',
    content: '之前一直找不到好用的苹果端免费看片软件，偶然发现91免费客户端的app，安装简单，资源齐全。Mac版也很好用，大屏看片体验完爆手机。希望一直保持免费！',
    likes: 96,
    avatar: '杰',
    avatarBg: 'bg-accent-500',
  },
  {
    name: '数码控小明',
    time: '1周前',
    content: '做为一个软件安全关注者，专门检测过91免费软件的安全性和隐私策略。结论是很靠谱——无恶意代码、不窃取隐私、不后台偷跑流量。免费看片软件里难得的良心产品。',
    likes: 203,
    avatar: '明',
    avatarBg: 'bg-secondary-500',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者评论</h2>
          <p className="mt-2 text-sm text-foreground-500">真实用户对91免费看片软件的评价</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentsData.map((comment, i) => (
            <div
              key={i}
              className="p-5 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-10 h-10 rounded-full ${comment.avatarBg} flex items-center justify-center text-background-50 font-heading text-sm font-bold flex-shrink-0`}>
                  {comment.avatar}
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
              <div className="mt-3 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}